"use strict";

exports.__esModule = true;
exports.notificationsState = exports.getNotifications = void 0;

var _reselect = require("reselect");

var notificationsState = function notificationsState(state) {
  return state.userInterfaceNotifications;
};

exports.notificationsState = notificationsState;
var getNotifications = (0, _reselect.createSelector)(notificationsState, function (state) {
  return state.notifications.sort(function (a, b) {
    return b.timeStamp - a.timeStamp;
  });
});
exports.getNotifications = getNotifications;